module.exports = __webpack_public_path__ + "img/krabi.31139e12.jpg";